const mime = require("mime-types");

const types = {
  file: "file-48_32.png",
  accdb: "accdb-48_32.png",
  avi: "avi-48_32.png",
  bmp: "bmp-48_32.png",
  css: "css-48_32.png",
  doc: "docx_win-48_32.png",
  docx: "docx_win-48_32.png",
  eml: "eml-48_32.png",
  eps: "eps-48_32.png",
  fla: "fla-48_32.png",
  gif: "gif-48_32.png",
  html: "html-48_32.png",
  ind: "ind-48_32.png",
  ini: "ini-48_32.png",
  jpg: "jpeg-48_32.png",
  jpeg: "jpeg-48_32.png",
  jsf: "jsf-48_32.png",
  midi: "midi-48_32.png",
  mov: "mov-48_32.png",
  mp3: "mp3-48_32.png",
  mpg: "mpeg-48_32.png",
  mpeg: "mpeg-48_32.png",
  pdf: "pdf-48_32.png",
  png: "png-48_32.png",
  ppt: "pptx_win-48_32.png",
  pptx: "pptx_win-48_32.png",
  proj: "proj-48_32.png",
  psd: "psd-48_32.png",
  pst: "pst-48_32.png",
  pub: "pub-48_32.png",
  rar: "rar-48_32.png",
  readme: "readme-48_32.png",
  settings: "settings-48_32.png",
  text: "text-48_32.png",
  txt: "text-48_32.png",
  tiff: "tiff-48_32.png",
  tif: "tiff-48_32.png",
  url: "url-48_32.png",
  vsd: "vsd-48_32.png",
  wav: "wav-48_32.png",
  wma: "wma-48_32.png",
  wmv: "wmv-48_32.png",
  xls: "xlsx_win-48_32.png",
  xlsx: "xlsx_win-48_32.png",
  zip: "zip-48_32.png",
};
module.exports = {
  getFile: (extension) => {
    let type = extension.toLowerCase();
    if (!types[type]) type = "file";
    return `https://s3.eu-west-2.amazonaws.com/venue.scanner/filetypes/${types[type]}`;
  },
  getContentType: (filepath) => {
    return mime.lookup(filepath);
  },
};
